module.exports = __webpack_public_path__ + "img/treeplant7_7-8-2021.fcebc3d1.jpg";